'use strict';

angular.module('mobile-apps').factory('PD', ['$resource',
	function($resource) {
		return $resource('v1/pd/:mobileAppId', {
			mobileAppId: '@mobileAppId'
		}, {
			configure: {
				method: 'POST',
				isArray: false,
				cache : false
			},
			instances: {
				method: 'GET',
				url : 'v1/pd/instances/:mobileAppId',
				isArray: true,
				cache: true
			},
            getLangCodes: {
                method: 'GET',
                url : '/v1/projects/:mobileAppId/pd/language-codes',
                isArray: true,
                cache: true,
            },
            getLanguagePairs: {
                method: 'GET',
                url : '/v1/projects/:mobileAppId/pd/language-pairs',
                isArray: true,
                cache: true,
            },
            saveLangCodes: {
                method: 'POST',
                url : '/v1/projects/:mobileAppId/pd/language-codes',
                isArray: false,
                cache: false,
            }
		});
	}
]);
